import { useCallback, useContext, useState } from 'react';

import { CurrentAliceAppContext } from '../context/aliceAppContext';
import { Context as SnapshotContext } from '../context/snapshotContext';
import { SmartHomeValidationStatuses } from '../model/draft';
import { makeValidationErrorMessage } from '../utils/draft-actions';

type SkillActions = {
    error: string;
    hasPendingAction: boolean;
    statuses?: SmartHomeValidationStatuses;
};

export const useSkillActionsWrapper = () => {
    const { refreshSnapshot } = useContext(SnapshotContext);
    const { aliceApp } = useContext(CurrentAliceAppContext)!;
    const [{ error, hasPendingAction, statuses }, setState] = useState<SkillActions>({
        error: '',
        hasPendingAction: false,
    });

    interface WrapHooks {
        onDone?: () => void;
    }

    const wrap = useCallback(
        function <T>(action: (_id: string) => Promise<T | void>, hooks?: WrapHooks) {
            return async () => {
                const { onDone } = hooks ?? {};
                setState({ hasPendingAction: true, error: '' });

                try {
                    const result = await action(aliceApp.id);
                    await refreshSnapshot();
                    setState({ hasPendingAction: false, error: '' });
                    onDone && onDone();

                    return result;
                } catch (e) {
                    const message = makeValidationErrorMessage(aliceApp.channel, e);
                    await refreshSnapshot();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const inferError = e as any;
                    setState({ hasPendingAction: false, error: message, statuses: inferError?.payload?.statuses });
                }
            };
        },
        [aliceApp, refreshSnapshot],
    );

    return {
        wrapper: wrap,
        error,
        hasPendingAction,
        statuses,
    };
};
